module.exports = __webpack_public_path__ + "img/tab4.51348f58.png";